import { twResolve } from "@/helpers/tw-resolve";

type MultiLineContentProps = {
  children: React.ReactNode;
  className?: string;
};

// Used for multi-line raw text from POEditor
export default function MultiLineContent({ children, className }: MultiLineContentProps): React.ReactNode {
  return <pre className={twResolve("whitespace-pre-line break-words font-sans", className)}>{children}</pre>;
}
